import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "saml";
const saml = createEndpointBase(base);

export const samlEndpoints = {
  samlAuthenticate: saml({ method: "GET", path: "", request: z.any(), response: z.any() }),
  samlRedirect: saml({ method: "POST", path: "redirect", request: z.any(), response: z.any() }),
} as const;
